import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import TaskHeader
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/TaskMessageContent/TaskHeader';
import TaskBody
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/TaskMessageContent/TaskBody';
import { noop } from 'Helpers/PropTypes';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('TaskMessageContent', (theme) => ({
  root: {
    paddingRight: theme.spacing(2),
  },
}));

const TaskMessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  // NOTE: Need to take care of case where actionItems is null

  useComponentDidMount(() => {
    onLoadComplete();
  });

  return (
    <Box className={classes.root}>
      <TaskHeader messageResource={messageResource} />
      {messageResource.attr('actionItems').resources().list().map(actionItem => (
        <TaskBody
          key={actionItem.id()}
          actionItem={actionItem}
        />
      ))
      }
    </Box>
  );
};

TaskMessageContent.defaultProps = {
  onLoadComplete: noop,
};

TaskMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};


export default TaskMessageContent;
